import PropTypes from 'prop-types';
import {
  format, isBefore, isToday,
} from 'date-fns';
import { fr } from 'date-fns/locale';

// Utils
import { cn } from '@repo/zolintra-utils';

// Styles
import styles from './PlanningHeaderCell.module.css';

function PlanningHeaderCell({ date }) {
  const dateIsPast = isBefore(new Date(date), new Date());
  const dateIsToday = isToday(new Date(date));

  return (
    <div className={cn([
      styles.container,
      dateIsToday ? styles.dateIsToday : '',
      dateIsPast && !dateIsToday ? styles.dateIsPast : '',
    ])}
    >
      <div className={styles.dayNb}>{format(date, 'd', { locale: fr })}</div>
      <div className={styles.date}>{format(date, 'iii', { locale: fr })}</div>
    </div>
  );
}

PlanningHeaderCell.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
};

export default PlanningHeaderCell;
